import React, { Suspense } from 'react'

import DateFnsUtils from '@date-io/date-fns'
import { CssBaseline } from '@material-ui/core'
import { ThemeProvider, makeStyles } from '@material-ui/core/styles'
import { MuiPickersUtilsProvider } from '@material-ui/pickers'
import { ThemeProvider as ThemeProviderV5 } from '@mui/material'
import { LicenseInfo } from '@mui/x-license-pro'
import { ErrorBoundary } from '@scoir/error-reporter'
import { ObserverProvider } from '@scoir/tracking'
import theme, { themeV5 } from 'material/theme'
import { Provider } from 'react-redux'
import { BrowserRouter, Route, Switch } from 'react-router-dom'
import { RouterToUrlQuery } from 'react-url-query'

import ErrorReporter from 'components/ErrorReporter'
import RecordImpression from 'components/RecordImpression'
import TrackPreviousPage from 'components/TrackPreviousPage'

import './App.scss'
import AppStartup from './AppStartup'
import GoogleAnalyticsConfiguration from './GoogleAnalyticsConfiguration'
import ConfiguredDynamicFeatureProvider from './components/ConfiguredDynamicFeatureProvider'
import { LoginRoute as WrapperLoginRoute } from './routes'
import ApplicationSingleSignOn from './routes/redirect/ApplicationSingleSignOn'
import store from './store'

const useGlobalStyles = makeStyles({
  '@global': {
    a: {
      color: theme.palette.primary.main,
      textDecoration: 'none',
      '&:hover': {
        textDecoration: 'underline',
      },
    },
  },
})
const App = () => {
  const ROOT_PATH = import.meta.env.BASE_URL
  const LOCAL_DEV = import.meta.env.DEV
  useGlobalStyles()
  LicenseInfo.setLicenseKey(window.MUI_PRO_KEY)

  return (
    <ErrorReporter>
      <ErrorBoundary>
        <ThemeProviderV5 theme={themeV5}>
          <ThemeProvider theme={theme}>
            <CssBaseline />
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <ObserverProvider>
                <RecordImpression>
                  <Suspense fallback={() => null}>
                    <BrowserRouter>
                      <TrackPreviousPage>
                        <Provider store={store}>
                          <GoogleAnalyticsConfiguration />
                          <ConfiguredDynamicFeatureProvider>
                            <RouterToUrlQuery>
                              <Switch>
                                {LOCAL_DEV && (
                                  <Route
                                    exact
                                    path={`${ROOT_PATH}/login`}
                                    component={WrapperLoginRoute}
                                  />
                                )}
                                <Route
                                  path={`${ROOT_PATH}/redirect/appl/:scid/:applId/sso`}
                                  component={ApplicationSingleSignOn}
                                />
                                <Route
                                  path={ROOT_PATH}
                                  component={AppStartup}
                                />
                              </Switch>
                            </RouterToUrlQuery>
                          </ConfiguredDynamicFeatureProvider>
                        </Provider>
                      </TrackPreviousPage>
                    </BrowserRouter>
                  </Suspense>
                </RecordImpression>
              </ObserverProvider>
            </MuiPickersUtilsProvider>
          </ThemeProvider>
        </ThemeProviderV5>
      </ErrorBoundary>
    </ErrorReporter>
  )
}

export default App
